import React from 'react'
import { useDispatch } from 'react-redux'
import { utilityAction } from 'reduxStore'
import PopupDialog from './PopupDialog'

export default function GlobalModal(props) {
    const { message, callBackOnClose, ...rest } = props
    const dispatch = useDispatch()

    const handleClose = event => {
        dispatch(utilityAction.showMsgBox({ show: false }))
        callBackOnClose()
    }

    return (
        <PopupDialog {...rest} closeHandle={handleClose}>{message}</PopupDialog>
    )
}

GlobalModal.defaultProps = {
    size: "md",
    zIndex: 2000,
    closeLabel: "Tutup",
    show: false,
    allowClose: true,
    linkToLabel: "",
    linkTo: "",
    callBackOnClose: () => { }
}
